import {
  DEFAULT_ERR,
  GET_API_CREDENTIAL_REQUEST,
  GET_API_CREDENTIAL_SUCCESS,
  GET_API_CREDENTIAL_FAILED,
} from '../types';
import API from '../../apiConfig';

import { setAlert } from './alert';

export const getAPICredential = (supplierId) => async (dispatch) => {
  dispatch({
    type: GET_API_CREDENTIAL_REQUEST,
  });
  try {
    API.get(`supplier/nic?supplierId=${supplierId}`)
      .then((res) => {
        dispatch({
          type: GET_API_CREDENTIAL_SUCCESS,
          response: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_API_CREDENTIAL_FAILED,
          message: err.message,
        });
        dispatch(setAlert(err.message, 'error'));
      });
  } catch (err) {
    dispatch({
      type: GET_API_CREDENTIAL_FAILED,
      message: DEFAULT_ERR,
    });
    dispatch(setAlert(DEFAULT_ERR, 'error'));
  }
};
